export const fromConnectionSpec = spec => {
  var _spec$portalId$toStri, _spec$portalId;
  if (!('portalId' in spec)) {
    return spec;
  }
  return Object.assign({}, spec, {
    portalId: (_spec$portalId$toStri = (_spec$portalId = spec.portalId) === null || _spec$portalId === void 0 ? void 0 : _spec$portalId.toString()) !== null && _spec$portalId$toStri !== void 0 ? _spec$portalId$toStri : null
  });
};